export const environment = {
  apiBaseUrl: 'https://api.sbv360.com',
  environment: 'prod',
  NX_APP_AZURE_AD_CLIENT_ID: '6db4a0bb-0055-4918-96cc-beb94ff09462',
  NX_APP_AZURE_AD_AUTHORITY:
    'https://login.microsoftonline.com/de9df500-9b25-4668-8c85-c9cce76cc306/v2.0',
  NX_APP_AZURE_AD_API_SCOPE: 'api://6db4a0bb-0055-4918-96cc-beb94ff09462/API',
};
